import React from "react";
import { Typography, Link } from "@mui/material";
export default () => {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href={process.env.REACT_APP_URL}>
                ASU-Helios Workforce
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}